<template>
  <div class="container-fluid" style="padding: 0px">
    <div class="row" v-if="loading">
      <div class="col-12 text-center">
        <img :src="require('@/assets/images/loading.svg')" alt="" style="width: 400px;max-width: 100%;">
      </div>
    </div>
    <div class="row" v-if="!loading">
      <div class="col-12 col-lg-3">
        <div class="card">
          <div class="card-header">
            توقيت الحصص <button class="btn btn-sm btn-primary" @click="create()" style="width: 30px; height: 30px; border-radius: 50%; padding: 0px">
              <i class="fa fa-plus"></i>
            </button>
          </div>
          <div class="card-body">
            <div class="list-group">
              <button
                type="button"
                :class="'list-group-item list-group-item-action ' + (t._id == current._id ? 'active' : '')"
                aria-current="true" v-for="t in times" :key="t._id" @click="current = t"
              >
                {{ t.title }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-9" v-if="current._id">
        <div class="card">
          <div class="card-body">
            
            <div class="row">

              <div class="col-12 col-lg-6">
                <p>ايام العمل</p>
                  <div class="row" style="padding-right: 20px">
                    <div class="form-check col-12 col-lg-6" v-for="d in days" :key="d.ar">
                    <input class="form-check-input" type="checkbox" :value="d.en" v-model="current.days" />
                    <label class="form-check-label" for=""> <h5>
                      {{ d.ar }}</h5> </label>
                  </div>
                  </div>
              </div>
              <div class="col-12 col-lg-6">
                <h5>العنوان</h5>
                <input
                    type="text"
                    class="form-control form-control-lg"
                    v-model="current.title"
                  />
                  <br>
                <div class="">
                  <h5 for="" class="form-label">اقصى عدد للحصص</h5>
                  <input
                    type="number"
                    class="form-control form-control-lg"
                    v-model="current.max_lessons"
                  />
                </div>
              </div>
            </div>
            <br>
            <p>اوقات الحصص</p>
            <div class="col-12 table-responsive">
              <table class='table table-hover table-bordered table-sm table-striped'>
                <thead>
                  <th>
                    الحصة
                  </th>
                  <th>
                    البداية
                  </th>
                  <th>
                    النهاية
                  </th>
                </thead>
                <tbody>
                  <template v-for="i in numberRange(0, current.max_lessons)">
                    <tr  :key="i" v-if="current.lessons_times[i+1]">
                      <td>
                        الحصة
                        {{ i+1 }}
                      </td>
                      <td>
                        <input type="time" v-model="current.lessons_times[i+1][0]" class="form-control">
                      </td>
                      <td>
                        <input type="time" v-model="current.lessons_times[i+1][1]" class="form-control">
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <br class="dnone">
              <p class="dnone">الحصص الفعالة</p>
              <table class="table table-sm table-hover table-bordered dnone">
                <thead>
                  <th>
                    اليوم
                  </th>
                  <th v-for="i in numberRange(0, current.max_lessons)" :key="i+11">
                    الحصة
                    {{ i+1 }}
                  </th>
                </thead>
                <tbody>
                  <template v-for="d in days">
                    <tr v-if="current.days.includes(d.en)" :key="19+d.ar">
                      <td>
                        {{ d.ar }}
                      </td>
                      <td v-for="i in numberRange(0, current.max_lessons)" :key="i+12">
                        <input class="form-check-inputs" type="checkbox" :value="true" v-model="current.days_lessons[d.en][i+1]" />
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <br>
            <div class="col-12 text-center">
              <button class="btn btn-primary" @click="save()">
                <i class="fa fa-check"></i>
                حفظ التعديلات 
              </button>
              &nbsp;&nbsp;
              <button class="btn text-danger" @click="deleteTime()">
                <i class="fa fa-trash"></i>
                حذف التوقيت
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      loading: true,
      times: [],
      current: {},
      user: JSON.parse(localStorage.getItem("user")),
      inter: null,
      days: [
        {
          ar: "السبت",
          en: "Saturday"
        },
        {
          ar: "الأحد",
          en: "Sunday"
        },
        {
          ar: "الإثنين",
          en: "Monday"
        },
        {
          ar: "الثلاثاء",
          en: "Tuesday"
        },
        {
          ar: "الأربعاء",
          en: "Wednesday"
        },
        {
          ar: "الخميس",
          en: "Thursday"
        },
        {
          ar: "الجمعة",
          en: "Friday"
        },
      ]
    }
  },
  beforeDestroy(){
    if(this.inter){
      clearInterval(this.inter)
    }
  },
  created(){
    var g = this;
    g.getTimes();
    this.inter = setInterval(() => {
      if(g.current._id){
        if(g.current.max_lessons > 10){
          g.current.max_lessons = 10;
        }
      }
    }, 100);
  },
  methods: {
    save(){
      var g = this;
      $.post(api + '/user/times/save', {
        jwt: g.user.jwt,
        id: g.current._id,
        days: JSON.stringify(g.current.days),
        max_lessons: g.current.max_lessons,
        title: g.current.title,
        days_lessons: JSON.stringify(g.current.days_lessons),
        lessons_times: JSON.stringify(g.current.lessons_times),
      }).then(function(r){
        if(r.status != 100){
          alert(r.response, 200)
        }else{
          g.current = {};
          g.getTimes()
          alert("تم الحفظ بنجاح", 100)
        }
      }).fail(function(){
        alert('حدث خطأ في الاتصال', 200)
      })
    },
    deleteTime(){
      var g = this;
      if(confirm(`متأكد من حذف التوقيت "${g.current.title}"؟`)){
        $.post(api + '/user/times/delete', {
          jwt: g.user.jwt,
          id: g.current._id
        }).then(function(r){
          if(r.status != 100){
            alert(r.response, 200)
          }else{
            g.current = {};
            g.getTimes()
          }
        }).fail(function(){
          alert('حدث خطأ في الاتصال', 200)
        })
      }
    },
    getTimes(){
      var g = this;
      g.loading = false;
      $.post(api + '/user/times/list', {
        jwt: g.user.jwt
      }).then(function(r){
        if(r.status != 100){
          alert(r.response, 200)
        }else{
          g.times = r.response;
          g.current = r.response[0] ?? {}
        }
      }).fail(function(){
        alert('حدث خطأ في الاتصال', 200)
      })
    },
    numberRange (start, end) {
      return new Array(end - start).fill().map((d, i) => i + start);
    },
    create(){
      var g = this;
      var t = prompt("عنوان التوقيت (اجباري)", "");
      if(t && t != ""){
        $.post(api + '/user/times/create', {
          jwt: g.user.jwt,
          title: t
        }).then(function(r){
          if(r.status != 100){
            alert(r.response, 200)
          }else{
            g.getTimes()
          }
        }).fail(function(){
          alert('حدث خطأ في الاتصال', 200)
        })
      }
    }
  }
}
</script>

<style>

</style>